import { Datagrid, FunctionField, List, Pagination } from "react-admin";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { RaRowActions } from "../../components/RaRowActions";
import { AppBulkDeleteButton } from "../../components/AppBulkDeleteButton";
import { RoleStatusDot } from "../../components/RoleStatusChip";
import { datagridSx, listCardSx } from "../../components/listStyles";

// Tela simples (poucos status fixos): sem busca/exportação — o "Novo" do
// breadcrumb cobre a criação. Padrão espelhado das Categorias de Sócios:
// clicar na linha abre a ficha; Editar/Excluir visíveis (antes ficavam
// escondidos atrás do menu "⋮"). A coluna "Membros" saiu: a API não
// devolve esse campo, então ela ficava sempre vazia.
export const UserRoleStatusList = () => {
  return (
    <>
      <PageTopBreadcrumb
        title="Status de Cargos e Funções"
        firstPath="/#/user-role-status/crud"
        actionType="create"
      />
      <List
        actions={false}
        perPage={20}
        pagination={<Pagination rowsPerPageOptions={[10, 20, 50]} />}
        queryOptions={{ keepPreviousData: true }}
        sx={listCardSx}
      >
        <Datagrid
          rowClick="show"
          bulkActionButtons={<AppBulkDeleteButton />}
          sx={datagridSx}
        >
          {/* sortable={false}: a API desta tela ignora a ordenação — a seta
              no cabeçalho prometeria algo que não acontece */}
          <FunctionField
            label="Status"
            sortable={false}
            render={(record: any) => <RoleStatusDot name={record.name} />}
          />
          <FunctionField
            label="Ações"
            textAlign="right"
            render={() => <RaRowActions />}
          />
        </Datagrid>
      </List>
    </>
  );
};
